/* eslint-disable */
import apiClient from './apiClient';

// ==================== Types ====================

export interface SettingType {
    key: string;
    label: string;
    icon: string;
}

export interface SettingItem {
    id: number;
    [key: string]: any;
}

export interface PaginatedResponse<T> {
    data: T[];
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
}

export interface ApiResponse<T> {
    success: boolean;
    data: T;
    message?: string;
}

// ==================== Settings Service ====================

export const settingsService = {
    async getTypes(): Promise<SettingType[]> {
        const response = await apiClient.get<ApiResponse<SettingType[]>>('/settings/types');
        return response.data.data;
    },

    async getAll(type: string, params: { per_page?: number; search?: string; is_active?: boolean } = {}): Promise<PaginatedResponse<SettingItem>> {
        const queryParams = new URLSearchParams();
        if (params.per_page) queryParams.append('per_page', params.per_page.toString());
        if (params.search) queryParams.append('search', params.search);
        if (params.is_active !== undefined) queryParams.append('is_active', params.is_active.toString());

        const response = await apiClient.get<PaginatedResponse<SettingItem>>(`/settings/${type}?${queryParams.toString()}`);
        return response.data;
    },

    async getById(type: string, id: number): Promise<SettingItem> {
        const response = await apiClient.get<ApiResponse<SettingItem>>(`/settings/${type}/${id}`);
        return response.data.data;
    },

    async create(type: string, data: Record<string, any>): Promise<SettingItem> {
        const response = await apiClient.post<ApiResponse<SettingItem>>(`/settings/${type}`, data);
        return response.data.data;
    },

    async update(type: string, id: number, data: Record<string, any>): Promise<SettingItem> {
        const response = await apiClient.put<ApiResponse<SettingItem>>(`/settings/${type}/${id}`, data);
        return response.data.data;
    },

    async delete(type: string, id: number): Promise<void> {
        await apiClient.delete(`/settings/${type}/${id}`);
    },
};

export default settingsService;
